export default __webpack_public_path__ + "static/media/1.9b32fe61.jpg";